import { ExportDataService } from '../services/file/export-data.service';
import { authGuard } from '../services/guards/auth.guard';
import { permissionGuard } from '../services/guards/permission.guard';
import { PermissionValue, ResourceValue } from '../services/permissions/permissions.types';
import { TitleTranslateResolver } from '../services/translate/title-translate.resolver';
import { ListingPageService } from '../shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from '../shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { ExportFileUrl } from '../shared/constants/export.constants';
import { EXPORT_URL_TOKEN } from '../shared/constants/tokens';
import { PortalPath, PortalRoute, RouteItem } from './app.types';
import { customersModelProvider } from './app.providers';
import { TranslateRegistry } from '../services/translate/translate.registry';
import { CustomersListingFiltersSourceService } from '../pages/csr/customers/customers-listing-filters-source.service';

export const customersRoutes: PortalRoute = {
  path: PortalPath.customers,
  canMatch: [authGuard, permissionGuard],
  data: {
    hasListingLayout: true,
    routeItem: new RouteItem({
      group: TranslateRegistry.get.MAIN_MENU.SECTION.CSR,
      title: TranslateRegistry.get.MAIN_MENU.TITLE.CUSTOMERS,
      hasRight: {
        resourceValue: ResourceValue.CUSTOMERS,
        targetPermissionValue: PermissionValue.VIEW
      },
      icon: 'customer-group',
      path: PortalPath.customers
    })
  },
  children: [
    {
      path: '',
      title: TitleTranslateResolver,
      data: {
        titleTranslation: TranslateRegistry.get.MAIN_MENU.TITLE.CUSTOMERS,
        hasListingLayout: true,
        routeItem: null
      },
      loadComponent: () =>
        import('../shared/components/listing-page/listing-page.component').then(c => c.ListingPageComponent),
      providers: [
        CustomersListingFiltersSourceService,
        customersModelProvider,
        ListingPageService,
        QueryParamsHandlerService,
        ExportDataService,
        { provide: EXPORT_URL_TOKEN, useValue: ExportFileUrl.Customers }
      ]
    },
    {
      path: ':customerUrlNumber',
      title: TitleTranslateResolver,
      data: {
        titleTranslation: 'Customer Details',
        // @skandratsiuk: TODO: To think about passed data.
        hasListingLayout: true,
        // @anikiforov: TODO: Need translation for `titleTranslation`.
        routeItem: new RouteItem({ title: '' })
      },
      loadComponent: () =>
        import('../pages/csr/customers/customer-details-page/customer-details-page.component').then(
          c => c.CustomerDetailsPageComponent
        ),
      providers: [
        customersModelProvider,
        ListingPageService,
        QueryParamsHandlerService,
        ExportDataService,
        { provide: EXPORT_URL_TOKEN, useValue: ExportFileUrl.Devices }
      ]
    }
  ]
};
